<template>
  <div>
    <v-card class="mb-3 sticky-element" :class="stickyClass">
      <v-layout row wrap justify-space-between >
        <v-flex xs12 sm6 class="pa-2">
          <v-layout row wrap>
            <v-flex shrink class="text-xs-center mr-3">
              <v-avatar size=48 >
                <v-icon color="primary" large>contact_support</v-icon>
              </v-avatar>
            </v-flex>
            <v-flex shrink class="grey--text" >
              <h1 class="grey--text text--darken-2">
                Contact Us
              </h1>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex class="text-xs-right mr-3">
          <v-btn flat small color="primary" to="/jargon/policy">
            Policies
          </v-btn>|
          <v-btn flat small color="primary" to="/jargon/pricing">
            Pricing
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card>

    <v-layout row>
      <v-flex>
        <v-expansion-panel disabled v-model="contactPanel">
          <v-expansion-panel-content class="v-expansion-panel-jargon">
            <v-card>
              <v-card-text>
                <h3 class="mb-3 grey--text text--darken-1">
                  Contact Information
                </h3>
                <p>
                  If for some reason you need to get a hold of us, you can do so through email.
                </p>

                <p>
                  <ul class="mt-2">
                    <li>
                      <h4>
                        Accounts and subscription support
                      </h4>
                      <a href="mailto:accounts@conductor-app.com">accounts@conductor-app.com</a>
                    </li>
                  </ul>
                </p>

                <p>
                  <ul class="mt-2">
                    <li>
                      <h4>
                        Technical support
                      </h4>
                      <a href="mailto:support@conductor-app.com">support@conductor-app.com</a>
                    </li>
                  </ul>
                </p>

                <p>
                  <ul class="mt-2">
                    <li>
                      <h4>
                        General enquiries
                      </h4>
                      <a href="mailto:info@conductor-app.com">info@conductor-app.com</a>
                    </li>
                  </ul>
                </p>

                <h3 class="mt-4 mb-2 grey--text text--darken-1">
                  Who we are
                </h3>
                <p>The Conductor ticket management system is a software service product that belongs to Shuntyard Technologies Pty Ltd.</p>
                <p>
                  Shuntyard Technologies Pty Ltd
                  <br>
                  ACN 669 558 427
                </p>
                <p>For more information about this product please email <a href="mailto:accounts@conductor-app.com">conductor@shuntyard.com</a></p>

              </v-card-text>
            </v-card>

          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  export default {
    name: 'jargon-show',

    data () {
      return {
        pricingPanel: 0,
        policyPanel: 0,
        contactPanel: 0
      }
    },

    components: {
    },

    watch: {
    },

    mounted () {
    },

    computed: {
      stickyClass () {
        if (window.innerWidth > 599) {
          if (this.scroll > 0) {
            return 'elevation-8'
          } else {
            return ''
          }
        }
      }
    },

    methods: {
    }
  }
</script>

<style lang="scss" scoped>
  .v-expansion-panel-jargon {
    background-color: #0155a8 !important;
  }

  h3 {
    font-weight: normal;
    text-transform: uppercase;
  }

</style>



// WEBPACK FOOTER //
// src/components/jargon/contact.vue